import Entity from './entity'
export default class QuestionTplDetValue extends Entity<number>{
	id:number;
	shortName:string;
    name:string;
	sort:number;
	file:string;
	suffix:string;
	status:string;
	totalCount:number;
	isChecked:boolean;
}